{ doAction, doActionWithServerValidations, fail, success } = require './index'

FAILED_CREATE_MESSAGE = 'Failed to create a new user'
SUCCEEDED_CREATE_MESSAGE = 'User created'
CREATED_USER = 'CREATED_USER'
CREATING_USER = 'CREATING_USER'

FAILED_DELETE_MESSAGE = 'Deletion failed'
SUCCEEDED_DELETE_MESSAGE = 'User deleted'
DELETED_USER = 'DELETED_USER'
DELETING_USER = 'DELETING_USER'

FAILED_FETCH_MESSAGE = 'Failed to retrieve the list of users from the server'
FETCHED_USERS = 'FETCHED_USERS'
FETCHING_USERS = 'FETCHING_USERS'

FAILED_UPDATE_MESSAGE = 'Update failed'
SUCCEEDED_UPDATE_MESSAGE = 'User updated'
UPDATED_USER = 'UPDATED_USER'
UPDATING_USER = 'UPDATING_USER'

SUCCEEDED_UPDATE_CURRENT_MESSAGE = 'Account updated'
UPDATED_CURRENT_USER = 'UPDATED_CURRENT_USER'
UPDATING_CURRENT_USER = 'UPDATING_CURRENT_USER'

url = '/api/users'

module.exports = {
	FAILED_CREATE_MESSAGE
	CREATED_USER
	CREATING_USER

	FAILED_DELETE_MESSAGE
	DELETED_USER
	DELETING_USER

	FAILED_FETCH_MESSAGE
	FETCHED_USERS
	FETCHING_USERS

	FAILED_UPDATE_MESSAGE
	UPDATED_USER
	UPDATING_USER

	UPDATED_CURRENT_USER
	UPDATING_CURRENT_USER

	createUser: (user) ->
		method = 'post'
		payload = user
		doingActionType = CREATING_USER
		didActionType = CREATED_USER
		failureMessage = FAILED_CREATE_MESSAGE
		successMessage = SUCCEEDED_CREATE_MESSAGE
		doActionWithServerValidations(url, method, payload, doingActionType, didActionType, failureMessage, successMessage)

	deleteUser: (userId) ->
		method = 'delete'
		payload = { id: userId }
		doingActionType = DELETING_USER
		didActionType = DELETED_USER
		failureMessage = FAILED_DELETE_MESSAGE
		successMessage = SUCCEEDED_DELETE_MESSAGE
		doAction(url, method, payload, doingActionType, didActionType, failureMessage, successMessage)

	fetchUsers: ->
		method = 'get'
		payload = null
		doingActionType = FETCHING_USERS
		didActionType = FETCHED_USERS
		failureMessage = FAILED_FETCH_MESSAGE
		doAction(url, method, payload, doingActionType, didActionType, failureMessage)

	updateUser: (user) ->
		method = 'PATCH'
		payload = user
		doingActionType = UPDATING_USER
		didActionType = UPDATED_USER
		failureMessage = FAILED_UPDATE_MESSAGE
		successMessage = SUCCEEDED_UPDATE_MESSAGE
		doActionWithServerValidations(url, method, payload, doingActionType, didActionType, failureMessage, successMessage)

	updateCurrentUser: (user) ->
		endpoint = url + '/' + user.id
		method = 'PATCH'
		payload = user
		doingActionType = UPDATING_CURRENT_USER
		didActionType = UPDATED_CURRENT_USER
		failureMessage = FAILED_UPDATE_MESSAGE
		successMessage = SUCCEEDED_UPDATE_CURRENT_MESSAGE

		getSuccessPayload = (responseJson) ->
			list: responseJson.data.list
			modified: responseJson.data.modified

		doActionWithServerValidations(endpoint, method, payload, doingActionType, didActionType, failureMessage, successMessage, getSuccessPayload)
}



// WEBPACK FOOTER //
// ./frontend/olos/js/actions/users.coffee